import React, { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { validatorTypes } from "@data-driven-forms/react-form-renderer";
import FormRenderer, { ComponentMapper, FormTemplate, componentTypes } from "../../../common/FormRenderer";
import { Button } from "react-bootstrap";
import { ACTIONS } from "../../../common/Constants";
import { useCreateLaw, useUpdateLaw } from "../../../../backend/masters";
import { toast } from "react-toastify";
import { API_RESULT, ERROR_MESSAGES } from "../../../../utils/constants";
import PageLoader from "../../../shared/PageLoader";
import { getValue } from "../../../../utils/common";
import { GetActionTitle } from "../Master.constants";
import { ResponseModel } from "../../../../models/responseModel";

function LawDetails({ action, record: data, onClose, onSubmit }: any) {
    const [law, setLaw] = useState<any>({ hideButtons: true });

    const schema = {
        fields: [
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'name',
                label: 'Law Name',
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                content: getValue(law, 'name')
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'description',
                label: 'Description',
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                content: getValue(law, 'description')
            }
        ],
    };

    useEffect(() => {
        if (data) {
            setLaw({ ...law, ...data });
        }
    }, [data]);

    return (
        <>
            <Modal show={true} backdrop="static" dialogClassName="drawer" animation={false}>
                <Modal.Header closeButton={true} onHide={onClose}>
                    <Modal.Title className="bg">{GetActionTitle('Law', action)}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormRenderer FormTemplate={FormTemplate}
                        initialValues={law}
                        componentMapper={ComponentMapper}
                        schema={schema}
                    />
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between">
                  {
                    <Button variant="primary" onClick={onClose} className="px-4 ms-auto">{'Close'}</Button>
                  }
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default LawDetails;
